import React from "react";
import {connect} from "react-redux";
import {Dimensions, StyleSheet, Text, TouchableOpacity, View} from "react-native";
import {wrapAction, wrapStyle} from "../../sw/helpers";
// focus picto
import FocusActivePicto from "../Picto/FocusActivePicto";
import FocusNotActivePicto from "../Picto/FocusNotActivePicto";
import FocusActiveCerclePicto from "../Picto/FocusActiveCerclePicto";
import FocusCerclePicto from "../Picto/FocusCerclePicto";
// notif picto
import NotifActiveCerclePicto from "../Picto/NotificationActiverActiveCerclePicto";
import NotifCerclePicto from "../Picto/NotificationActiverCerclePicto";
import FooterNotifActivePicto from "../Picto/FooterNotificationActivePicto";
import FooterNotifPicto from "../Picto/FooterNotificationPicto.tsx";
// other picto
import ConfidentialPicto from "../Picto/ConfidentialPicto";


class ExplorerThemeListItem extends React.Component{
    constructor(props) {
        super(props);
        this.onLinePress = this.onLinePress.bind(this);
    }

    createStyle() {
        return StyleSheet.create({
            container:{
                width:"90%",
                backgroundColor:this.props.theme.colors.primary.White.value,
                justifyContent:"center",
                marginBottom:12,
                borderRadius:10
            },
            text :{
                fontSize:15,
                fontFamily:this.props.theme.fonts.text,
                color:this.props.theme.colors.tertiary.black1.value,
                fontWeight:"600",
                padding:20,
                flexGrow: 1,
            },
            containerChild:{
                marginBottom:1
            },
            separatorLine:{
                width:"100%",
                height:1,
                backgroundColor:this.props.theme.colors.tertiary.black13.value,
            },
            trait:{
                width:20,
                height:1,
                backgroundColor:this.props.theme.colors.primary.blue1.value
            },
            containerTextChild: {
                flexDirection:"row",
                alignItems:"center",
                marginLeft:20
            },
            containerTextChildChild :{
                flexDirection:"row",
                alignItems:"center",
                marginLeft:40
            }
        });
    }

    wrapStyleIfUpdate() {
      const s = {
	marginRight:20,
	flexDirection: "row",
	alignItems:"center"
      }

      return this.props.isUpdate ? wrapStyle(s) : s;
    }

    // focus
    isFocused(id) {
        return (this.props.focusList || []).some(element => element.id == id);
    }

    isInFocusSet(id){
        return (this.props.focusListSet || []).some(element => element.id == id);
    }

    isInFocusUnset(id){
        return (this.props.focusListUnSet || []).some(element => element.id == id);
    }

    // notify
    isNotification(id) {
        return (this.props.notificationList || []).some(element => element.id == id);
    }

    isInNotificationSet(id){
        return (this.props.notificationListSet || []).some(element => element.id == id);
    }

    isInNotificationUnset(id){
        return (this.props.notificationListUnSet || []).some(element => element.id == id);
    }

    onPressFocus(item){
        let isFocused = this.isFocused(item.id);
        let isInSet = this.isInFocusSet(item.id);
        let isInUnset = this.isInFocusUnset(item.id);

        const is_set = (isInUnset || !isFocused) && !isInSet;

        this.props.setFocusList("theme", is_set, item);
    }

    onPressNotification(item){
        let isNotification = this.isNotification(item.id);
        let isInSet = this.isInNotificationSet(item.id);
        let isInUnset = this.isInNotificationUnset(item.id);

        const is_set = (isInUnset || !isNotification) && !isInSet;

        this.props.setNotificationList("theme", is_set, item);
    }

    // type can be leaf/root/subroot
    getPictoWhenNoUpdate(item, type) {
      if (type == "leaf") {
	return <View style={{display: "flex"}}>
	  { this.props.isFocus && <FocusActivePicto isHeader={true} style={{width:25}} /> }
	  { this.props.isNotification && <FooterNotifActivePicto isHeader={true} style={{width:21}} /> }
	</View>
      }

     return (
       this.props.isFocus &&
       (item.children.length==0 || (item.children.length>0 && this.getPictoWhenUpdate(item))) &&
       this.getPictoWhenUpdate(item)
     );
    }
    getPictoWhenUpdate(item) {
      let isFocused = this.isFocused(item.id);
      let isInFocusSet = this.isInFocusSet(item.id);
      let isInFocusUnSet = this.isInFocusUnset(item.id);
      const { isUpdate } = this.props;

      let focus_icon = false;

      const notif_style = {width: 21};
      const focus_style = {width: 25, marginLeft: 15};

      const notif_cercle_style = {width: 30};
      const focus_cercle_style = {width: 30, marginLeft: 15};


      if ((isFocused || isInFocusSet) && !isInFocusUnSet) {
        focus_icon = (
          isUpdate ? <FocusActiveCerclePicto isHeader={true} style={focus_cercle_style} />
                   : <FocusActivePicto isHeader={true} style={focus_style} />
	 )
      } else if ((!isFocused || isInFocusUnSet) && !isInFocusSet) {
        focus_icon = (
	  isUpdate ? <FocusCerclePicto isHeader={true} style={focus_cercle_style} />
	           : <FocusNotActivePicto isHeader={true} style={focus_style} />
	)
      }

      let isNotification = this.isNotification(item.id);
      let isInNotificationSet = this.isInNotificationSet(item.id);
      let isInNotificationUnSet = this.isInNotificationUnset(item.id);

      let notification_icon = false;

      if ((isNotification || isInNotificationSet) && !isInNotificationUnSet) {
        notification_icon = (
	  isUpdate ? <NotifActiveCerclePicto isHeader={true} style={notif_cercle_style} />
	           : <FooterNotifActivePicto isHeader={true} style={notif_style} />
	)
      } else if ((!isNotification || isInNotificationUnSet) && !isInNotificationSet) {
        notification_icon = (
	  isUpdate ? <NotifCerclePicto isHeader={true} style={notif_cercle_style} />
	           : <FooterNotifPicto isHeader={true} style={notif_style} />
	)
      }

      if (!notification_icon && !focus_icon) {
	return false;
      }

      // deactivate clicking... is not update
      if (! this.props.isUpdate) {
	return <View style={{display: "flex", flexDirection: "row"}}>
	  { notification_icon }
	  { focus_icon }
	</View>
      }

      return <View style={{display: "flex", flexDirection: "row"}}>
	{
          notification_icon &&
	  <TouchableOpacity onPress={wrapAction(() => this.onPressNotification(item))}>
	    { notification_icon }
	  </TouchableOpacity>
	}
	{
          focus_icon &&
	  <TouchableOpacity onPress={wrapAction(() => this.onPressFocus(item))}>
	    { focus_icon }
	  </TouchableOpacity>
	}
      </View>
    }

    onLinePress(item) {
      if (! this.props.isUpdate) {
        this.props.navigateToEntityScreen(item)
      }
      // if update, we do nothing, action takes place when click on icon
      // don't move to item, otherwise we might loose the edition
    }

    renderRoot(item, styles) {
      return <View style={styles.container} key={item.id}>

        <TouchableOpacity onPress={() => this.onLinePress(item)}>
          <View style={{display: "flex", flexDirection: "row", alignItems: "center"}}>
            <Text style={styles.text}>{item.item}</Text>
            <View style={this.wrapStyleIfUpdate()}>
		{ item.confidential && <ConfidentialPicto style={{width: 21, height: 21, marginRight: 15}} isHeader={true}/> }
                { this.props.isUpdate && this.getPictoWhenUpdate(item) }
                { !this.props.isUpdate && this.getPictoWhenNoUpdate(item, "root") }
            </View>
          </View>
        </TouchableOpacity>

        <View style={styles.separatorLine} />

        { item.children.map((child, index)=> this.renderSubRoot(child, styles, index == item.children.length - 1)) }
      </View>
    }

    renderSubRoot(item, styles, is_last) {
      return <View style={styles.containerChild} key={item.id}>

        <TouchableOpacity onPress={() => this.onLinePress(item)}>
          <View style={styles.containerTextChild}>
              <View style={styles.trait}></View>
              <Text style={styles.text}>{item.item}</Text>

              <View style={this.wrapStyleIfUpdate()}>
		{ item.confidential && <ConfidentialPicto style={{width: 21, height: 21, marginRight: 15}} isHeader={true}/> }
                { this.props.isUpdate && this.getPictoWhenUpdate(item) }
                { !this.props.isUpdate && this.getPictoWhenNoUpdate(item, "subroot") }
              </View>
          </View>
        </TouchableOpacity>

        { item.children.length != 0 && !is_last && <View style={styles.separatorLine} /> }

        { item.children.map((child, index) => this.renderLeaf(child, styles, is_last, index == item.children.length - 1)) }
      </View>
    }

    renderLeaf(item, styles, is_subroot_last, is_leaf_last) {
      return <View style={styles.containerChild} key={item.id}>

        <TouchableOpacity onPress={() => this.onLinePress(item)}>
          <View style={styles.containerTextChildChild}>
            <View style={styles.trait}></View>
            <Text style={styles.text}>{item.item}</Text>

            <View style={this.wrapStyleIfUpdate()}>
	       { item.confidential && <ConfidentialPicto style={{width: 21, height: 21, marginRight: 15}} isHeader={true}/> }
               { this.props.isUpdate && this.getPictoWhenUpdate(item) }
               { !this.props.isUpdate && this.getPictoWhenNoUpdate(item, "leaf") }
            </View>
          </View>
        </TouchableOpacity>

        { !is_subroot_last && !is_leaf_last && <View style={styles.separatorLine} /> }

      </View>
    }

    render(){
        const styles = this.createStyle();

        // rendering a root
        return <View style={{justifyContent:"center",alignItems:"center",marginBottom:15}}>
          { this.renderRoot(this.props.item, styles) }
        </View>
    }
}

const mapStateToProps = (state) => {
    return {
      isDark: state.changeTheme.isDark,theme: state.changeTheme.theme, auth : state.AuthReducer,
      online: state.sw_reducer.online
    }
}

export default connect(mapStateToProps)(ExplorerThemeListItem);
